import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviews } from "src/redux/slices/reviews";
import Review from "src/sections/reviews/components/review";

// ОТЗЫВЫ О КОНКРЕТНОМ ТУРЕ.
//
// Стоят внизу страницы, после программы по дням и списка «включено» — то
// есть там, где человек уже всё прочитал и решает, ехать или нет. Отзыв
// именно про этот маршрут в этот момент весит больше, чем отзыв о компании
// вообще: он отвечает на вопрос «а как оно на самом деле было».
//
// Отзывы привязывает к туру менеджер в админке («Отзывы» → «Куда добавить»).
// Их нет — блока тоже нет: пустое «отзывов пока нет» на странице тура за
// 2600 $ работает против продажи.
export default function TourReviews({ activityId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const reviews = useSelector((state) =>
    state.reviews.reviews.items.filter(
      (review) => review.activityId && review.activityId === activityId
    )
  );

  useEffect(() => {
    dispatch(fetchReviews());
  }, [dispatch]);

  if (!activityId || reviews.length === 0) return null;

  return (
    <section className="w-full">
      <h2 className="text-xl sm:text-2xl font-extrabold uppercase tracking-tight text-kj-ink">
        {t("tour.reviewsTitle")}
      </h2>
      <p className="mt-2 text-base text-kj-sub max-w-xl leading-relaxed">
        {t("tour.reviewsSubtitle")}
      </p>

      <div className="mt-2 divide-y divide-kj-line">
        {[...reviews].reverse().map((review) => (
          <Review
            key={review._id}
            name={review.name}
            date={review.date}
            stars={review.stars}
            comment={review.comment}
            photos={review.photos}
          />
        ))}
      </div>
    </section>
  );
}
